export const AUTH_PAGE_CONTENT = {
  login: {
    heading: 'Welcome back',
    paragraph:
      'Sign in to pick up where you left off and keep building with Miles.',
    providerAction: 'Sign in',
    showAgencyEmail: true,
    alternatePrompt: 'New to Miles?',
    alternateLabel: 'Create an account',
    alternatePath: '/signup',
    documentTitle: 'Sign in to Miles',
  },
  signup: {
    heading: 'Create your Miles account',
    paragraph: 'Start your first custom WordPress design with Miles.',
    providerAction: 'Sign up',
    showAgencyEmail: false,
    alternatePrompt: 'Already have an account?',
    alternateLabel: 'Sign in',
    alternatePath: '/login',
    documentTitle: 'Sign up for Miles',
  },
} as const;

export type AuthMode = keyof typeof AUTH_PAGE_CONTENT;
